import { useHttp } from '@/api';
import { install } from '@/auth/auth';
import locales from '@/locales';
import { constantRoutes } from '@/router/constant';
import { routerAuthConfig } from '@/router/index';
import domain from '@/validation/domain';
import forms from '@/validation/form';
import { CheckAge, MaxValue, MinValue, ValidateUniqueChars } from "@/validation/validator";
import { useLocale } from '@tellus/locale';
import uiPluginDomain from '@tellus/ui-plugin-domain';
import ja from '@tellus/ui/lib/locale/lang/ja';
const ROUTER_AUTH_NAMESPACE = Symbol('tellus-router-auth')
const routerAuthPlugin = {
  name: ROUTER_AUTH_NAMESPACE,
  version: '__VERSION__',
  install: install
}

export default {
  UI: {
    locale: ja,
    plugins: [uiPluginDomain],
  },
  Domain: {
    base: domain,
    forms: forms,
    renderMessageFn: (key, value) => useLocale().t(key, value),
    maxin: {

      rules: {
        password: {
              message: 'message.VALIDATION.PASSWORD_ERROR',
              value: /^[a-zA-Z0-9\!\-\@\.\_]*$/
        },

        tel: {
              message: 'message.VALIDATION.TEL_MUST_CORRECT',
              value: /^[0-9\+\-\-_]*$/
        }

      },

      // 扩展的自定义校验方法， callback 决定校验成功或失败
      validators: {
        CheckAge: CheckAge,
        MaxValue: MaxValue,
        MinValue: MinValue,
        ValidateUniqueChars : ValidateUniqueChars,
      }
    }

  },
  Router: {
    base: process.env.VUE_APP_PUBLISH_PATH,
    plugins: [routerAuthPlugin],
    routes: constantRoutes
  },
  RouterAuth: {
    ...routerAuthConfig
  },
  Http: {
    timeout: 1000,
    modules: [useHttp]
  },
  Locale: {
    fallbackLocale: 'ja',
    // set default locale language
    locale: 'ja',
    supportLocales: ['en', 'ja', 'zh'],
    // Add locale messages to i18n
    messages: locales,
    silentTranslationWarn: true
  },
  Layout: {
    // 全局配置
    global: {
      // 是否显示页脚
      showFooter: false,
    },
    sidebar: {
      // sidebar menu bg color
      bgColor: '#304156',//'#CCCCFF',
      // sidebar menu text color
      textColor: '#FFFFFF',
      // sidebar menu active text color
      activeTextColor: '#E7C257',//'#5F41B2',
      // Whether to fix the left menu
      fixed: false,
      // Menu collapse
      collapsed: false,
      // Whether to display the menu name when folding the menu
      collapsedShowTitle: false,
      // Menu width
      menuWidth: 200,
      // Split menu
      split: false,
      // Menu type 'sidebar' | 'topMenu'
      type: 'sidebar',
      // Top menu layout 'center' | 'start' | 'end'
      topMenuAlign: 'center',
      // Whether to open the folding animation
      accordion: true,
      // Whether Only one submenu can be expanded at a time
      uniqueOpened: false,
      // Whether the menu can be initially expanded
      openedsMenu: true,
      // Menu Initialization Expand Item
      openedsMenuOptions: []
    },
    header: {
      // 是否在顶部固定标题
      fixedHeader: true,
      // 顶部背景颜色
      bgColor: '#C1CBD7',//'#FFFFFF',
      // 顶部高度
      headerHeight: 58
    }
  },
}
